export default function () {
  const widgetName = 'managedeventfeed';
  const widgetOpts = managedeventfeedOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const $container = $(
        '<div class="multiFeatureContent"><a href="../events" class="all-events-btn">VIEW ALL EVENTS</a></div>',
      );
      $(`#${widgetName}`).append($container);

      $(`#${widgetName} .card-widget-item`).each(function () {
        $container.append($(this));

        // Create a new wrapper div for description and button
        const $wrapperDiv = $('<div class="description-button-wrapper"></div>');

        // Move the description span into the new wrapper div
        const $descriptionSpan = $(this).find('.card-widget-description');
        if ($descriptionSpan.length) {
          $wrapperDiv.append($descriptionSpan);
        }

        // Find and move the button into the wrapper div
        const $button = $(this).find('.buttonwrap'); // Adjust selector based on your button's class
        if ($button.length) {
          $wrapperDiv.append($button);
        }

        // Append the new wrapper div to the card widget item
        $(this).append($wrapperDiv);
      });

      $(`#${widgetName} .card-widget-item .card-content`).each(function (i) {
        $(`#${widgetName} .card-widget-item.void-link`).removeAttr('href');

        if (data.items[i].DateRange) {
          let rawDate = data.items[i].DateRange;
          let m = rawDate;
          let dateHTML = `
            <div class="card-widget-date">
              <span>${m}</span>
            </div>
          `;
          $(this).prepend(dateHTML);
        }

        const titleLimit = 45;
        const titleElement = $(this).find('.card-widget-title');
        const titleText = titleElement.text();
        if (titleText.length > titleLimit) {
          const truncatedText = titleText.substring(0, titleLimit) + '...';
          titleElement.text(truncatedText);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 10,
    moreButton: {
      visible: true,
      text: 'More >',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
